var makeString = require('./helper/makeString');

module.exports = function stripTags(str) {
  return makeString(str).replace(/<\/?[^>]+>/g, '');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore.string/stripTags.js
 ** module id = 1930
 ** module chunks = 0
 **/